export const CNFUtils = {
  parseFormula: (formulaStr) => {
    let normalized = formulaStr.replace(/\band\b/gi, '&').replace(/∧/g, '&').replace(/\bor\b/gi, '|').replace(/∨/g, '|').replace(/~/g, '!').replace(/¬/g, '!');
    const clauseStrings = normalized.split('&').map(s => s.trim());
    return clauseStrings.map(clauseStr => {
      clauseStr = clauseStr.replace(/^\(|\)$/g, '').trim();
      const literalStrings = clauseStr.split('|').map(s => s.trim());
      const literals = literalStrings.map(lit => ({ negated: lit.startsWith('!'), variable: lit.replace(/^!/, '').trim() })).filter(lit => lit.variable);
      return { literals };
    }).filter(clause => clause.literals.length > 0);
  },
  evaluateClause: (literals, assignment) => literals.some(lit => { const value = assignment[lit.variable]; return lit.negated ? !value : value; }),
  getAllVariables: (clauses) => { const vars = new Set(); clauses.forEach(clause => clause.literals.forEach(lit => vars.add(lit.variable))); return Array.from(vars).sort(); }
};